import { NOT_LOGGED_IN, USER_LOGGED_IN } from '../actions';

const authReducer = (oldState = {
  authVm: {
    email: '',
    emailVerified: undefined,
    uid: undefined
  }
}, action) => {
  switch (action.type) {
    case NOT_LOGGED_IN:
      return {
        authVm: {
          email: '',
          emailVerified: false,
          uid: undefined
        }
      };
    case USER_LOGGED_IN:
      return { authVm: action.response };
    default:
      return oldState;
  }
};

export default authReducer;



// WEBPACK FOOTER //
// ./src/pages/authReducer.js